import styled from 'styled-components';

export const Container = styled.div`
  flex-shrink: 0;
  min-width: 328px;
  padding-top: 12px;
  > button {
    float: right;
    margin-top: 18px;
  }
`;
